import { IconButton, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import { MoreHorizOutlined } from '@material-ui/icons';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import Truncate from 'v2/components/Shared/TruncateText';

import type { SubscriptionPlan } from 'v2/interfaces/product';

import { SubscriptionFrequency } from '../../../SubscriptionPlan/ListSubscriptionPlan/constants';

type ListSubscriptionPlan = {
  handleActionsClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, plan: SubscriptionPlan) => void;
  isLoading: boolean;
  isError: boolean;
  plans: SubscriptionPlan[];
};

function TableState({ message }: { message: string }) {
  return (
    <TableRow>
      <TableCell colSpan={6} align='center' style={{ padding: 16 }}>
        {message}
      </TableCell>
    </TableRow>
  );
}

function formatCommission(value: number) {
  const withLeadingZero = value < 10 ? `0${value}` : value.toString();
  return `${withLeadingZero.replace('.', ',')}%`;
}

export const ListSubscriptionPlans = ({ handleActionsClick, isLoading, isError, plans }: ListSubscriptionPlan) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableCell>Plano</TableCell>
          <TableCell>Frequência</TableCell>
          <TableCell>Valor</TableCell>
          <TableCell>Comissão</TableCell>
          <TableCell align='center'>Ações</TableCell>
        </TableHead>
        <TableBody>
          {isLoading && <TableState message='Carregando...' />}
          {!isLoading && !plans?.length && !isError && <TableState message='Nenhum plano cadastrado para este produto' />}
          {isError && <TableState message='Ocorreu um erro ao carregar os planos' />}

          {plans?.map((row, index) => (
            <TableRow key={row.plan_id}>
              <TableCell>
                <Truncate count={30}>{row.plan_title}</Truncate>
              </TableCell>
              <TableCell>{SubscriptionFrequency[row.plan_frequencia]}</TableCell>
              <TableCell>
                <FormattedNumber value={row.plan_value || 0} format='BRL' />
              </TableCell>
              <TableCell>
                <span style={{ minWidth: 170, display: 'inline-block' }}>{formatCommission(row.plan_reccomissao_valor)} na recorrência</span>

                <span>{row.membership_fee ? `${formatCommission(row.plan_comissao_valor)} na adesão` : ''}</span>
              </TableCell>
              <TableCell align='center'>
                <IconButton id={`plan-actions-${index}`} size='small' onClick={(event) => handleActionsClick(event, row)}>
                  <MoreHorizOutlined />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
